import Flex from 'components/Flex'
import Radio from 'components/Form/RadioButton'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const RadioGroups = styled(RadioGroup)`
  flex-direction: column;
  span.ant-radio + * {
    width: 100% !important;
  }
`
export const Radios = styled(Radio)`
  border-bottom: 1px solid ${COLORS.GREY_T_90} !important;
  font-weight: ${FONT.FW_600} !important;
  font-size: ${FONT.F_SM} !important;
  color: ${COLORS.GREY_T_20} !important;
  padding: 0 0 18px 0;
  margin: 0;
  border-radius: 0px;
  align-items: center;
  .ant-radio {
    top: 0;
  }
`

export const SelectClgDiv = styled.div`
  font-style: normal;

  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_20};
  background: ${props =>
    props.background ? props.background : COLORS.GREY_T_95};
  border-radius: 6px;
  padding: 4px 6px;
`
export const FooterFlex = styled(Flex)`
  gap: 10px;
`
export const CollageNameFlex = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  margin-left: 10px;
`
export const CollegeNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_20};
`
export const CollegeCity = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
`
export const CollageDetailsFlex = styled(Flex)`
  line-height: normal;
  width: 100%;
  align-items: center;
  padding-bottom: 12px;
`

export const CandidatesSpan = styled.span`
  padding: 2px 6px;
  margin-left: 10px;
  width: 29px;
  height: 19px;
  background: ${COLORS.PAGE_BORDER};
  border-radius: 20px;
`
